import { apiPost } from 'services/_http';
import { urls } from 'services/_url';

const base_url = `${urls.api}/v1`;
export const triggerEvent = async (options = {}) => {
  return await apiPost(`${base_url}/automations`, { ...options });
};
